import { Component, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { snackbarProgressTimer } from '@orderna/admin-panel/src/utils/snackbar-progress-timer';

@Component({
  selector: 'app-error-snackbar',
  standalone: true,
  imports: [MatIconModule, MatProgressBarModule],
  templateUrl: './error-snackbar.component.html',
  styleUrl: './error-snackbar.component.css',
})
export class ErrorSnackbarComponent {
  protected progress: number = 100;
  private readonly SNACKBAR_TYPE: string = 'Error';

  constructor(
    public snackBarRef: MatSnackBarRef<ErrorSnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA)
    public data: { message: string; duration: number }
  ) {}

  ngOnInit(): void {
    const onProgress = (progress: number) => (this.progress = progress);
    const timer = snackbarProgressTimer(
      onProgress,
      this.SNACKBAR_TYPE,
      this.progress,
      this.data.duration
    );

    this.snackBarRef.afterDismissed().subscribe(() => {
      timer();
    });
  }

  protected dismiss(): void {
    this.snackBarRef.dismissWithAction();
  }
}
